<template>
  <div class="task-modal-price-type-toggle" role="tablist" aria-label="Price type">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      role="tab"
      class="task-modal-price-type-toggle__segment"
      :class="{ 'task-modal-price-type-toggle__segment--selected': modelValue === opt.value }"
      :aria-selected="modelValue === opt.value"
      @click="$emit('update:modelValue', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
import { TASK_PRICE_TYPE_OPTIONS } from '../../../../helpers/taskPricing'

export default {
  name: 'TaskModalPriceTypeToggle',
  compatConfig: {
    COMPONENT_V_MODEL: false
  },
  props: {
    modelValue: {
      type: String,
      default: 'standard'
    },
    options: {
      type: Array,
      default: function () {
        return TASK_PRICE_TYPE_OPTIONS
      }
    }
  }
}
</script>
